module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<h3 class=\"title\"><a role=\"button\" class=\"switch\" data-toggle=\"collapse\" data-target=\"#behaviors-options\">Behaviors <i class=\"fa pf-carot-down\"></i></a></h3>\r\n<div id=\"behaviors-options\" class=\"collapse in\">\r\n    <ul class=\"behavior-options\">\r\n        ")
    ;  if (behaviors) {
            _.forEach(behaviors, function(behavior) {
                if (isMobile) {
                    var compatibleClass = '';
                    var active = behavior.active;

                    if (!behavior.mobileCompatible && behavior.active)  {
                        compatibleClass = 'no-compatible no-compatible-red';
                        active = '';
                    }

                    if (!behavior.mobileCompatible && !behavior.active)  {
                        compatibleClass = 'no-compatible no-compatible-black';
                        active = '';
                    }

                    
    ; __append("\r\n                    <li class=\"behavior-options ")
    ; __append(escapeFn(compatibleClass))
    ; __append("\" style=\"display: block;\">\r\n                        <a role=\"button\" class=\"behaviorLink ")
    ; __append(escapeFn(active))
    ; __append("\" data-objectid=\"")
    ; __append(escapeFn(id))
    ; __append("\" data-behaviorkey=\"")
    ; __append(escapeFn(behavior.behaviorKey))
    ; __append("\">\r\n                            ")
    ; __append(escapeFn(behavior.text))
    ; __append("\r\n                        </a>\r\n                    </li>\r\n            ")
    ;   }
                else {
            
    ; __append("\r\n                    <li>\r\n                        <a role=\"button\" class=\"behaviorLink ")
    ; __append(escapeFn(behavior.active))
    ; __append("\" data-objectid=\"")
    ; __append(escapeFn(id))
    ; __append("\" data-behaviorkey=\"")
    ; __append(escapeFn(behavior.behaviorKey))
    ; __append("\">\r\n                            ")
    ; __append(escapeFn(behavior.text))
    ; __append("\r\n                        </a>\r\n                    </li>\r\n            ")
    ; 
                }
            });
        }
    ; __append("\r\n    </ul>\r\n    <div id=\"prop-behavior-view\"></div>\r\n</div>")
  }
  return __output;

}